import React, { Component } from "react";
import ChartistGraph from "react-chartist";
import {
  Grid,
  Row,
  Col,
  Alert,
  FormGroup,
  ControlLabel,
  Table
} from "react-bootstrap";

import Slider from "react-slick";


import Button from "../../components/CustomButton/CustomButton.jsx";
import InputMask from 'react-input-mask';

import { Query } from "react-apollo";
import gql from "graphql-tag";
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';

import { FormInputs } from "../../components/FormInputs/FormInputs.jsx";
import { StatsCard } from "../../components/StatsCard/StatsCard.jsx";

import TrailList from "../../components/Trail/List.jsx";
import TrailListReport from "../../components/Trail/ListReport.jsx";
import CategoryList from "../../components/Category/List.jsx";
import CategoryListAdmin from "../../components/Category/ListAdmin.jsx";



const restLink_dam = new HttpLink({ 
  uri: "/api/v1/dam/",
  credentials: 'include'
});
const dam_client = new ApolloClient({
  link: restLink_dam,
  cache: new InMemoryCache(),
});

const restLink_lms = new HttpLink({ 
  uri: "/api/v1/lms/",
  credentials: 'include'
});
const lms_client = new ApolloClient({
  link: restLink_lms,
  cache: new InMemoryCache(),
});

const restLink_cms = new HttpLink({ 
  uri: "/api/v1/cms/",
  credentials: 'include'
});
const cms_client = new ApolloClient({
  link: restLink_cms,
  cache: new InMemoryCache(),
});

const restLink_analytics = new HttpLink({ 
  uri: "/api/v1/analytics/",
  credentials: 'include'
});
const analytics_client = new ApolloClient({
  link: restLink_analytics,
  cache: new InMemoryCache(),
});

const restLink_account = new HttpLink({ 
  uri: "/api/v1/account/",
  credentials: 'include'
 });
const account_client = new ApolloClient({
  link: restLink_account,
  cache: new InMemoryCache(),
});

const GET_AUTH_USER = gql`{
  get_authenticated_user{
    id
    profile{
      id
      is_admin
    }
  }
}
`;

const GET_DAM = gql`
  query getDam($module_name: String!){
    assets_collections(limit:5,order:"DESC",module_name:$module_name) {
      assets{
        id, title, asset, directlink
      }
    }
  }`;


const GET_CURSES = gql`{
    courses_collections(type:"online"){
      courses{
        id,title,thumbnail
      }
    }
  }
`;

const GET_VIDEOS_TRENDING = gql`{
  videos_trending{
    videos{
      id, title, thumbnail
    }
  }
}
`;

const GET_TESTIMONY = gql`
  {
  contents_collections(limit:4,order:"DESC",module_name:"Testimony") {
      contents{
        id, title, content, thumbnail, directlink
      }
    }
  }
`;


const ANALYTICS_INSERT_BANNER_CLICK = gql`
  mutation createBanner($banner_id: Int!, $banner_title: String!) {
    createBanner(input:{banner_id: $banner_id, banner_title: $banner_title}) {
    id
    }
  }
`;


const REGISTER_UPDATE = gql`
  mutation updateUser($id: Int!, $type: String!, $name: String!, $mail: String!, $phone: String!, $uid: String!, $profile_id: Int!, $is_blocked: Int!, $blocked_description: String!){
    updateUser(id:$id, input:{type:$type, name:$name, mail:$mail, phone:$phone, uid:$uid, profile_id:$profile_id, is_blocked:$is_blocked, blocked_description:$blocked_description}){
      id
      token
      msg
      msg_error
    }
  }
`;



class Dashboard extends Component {

  constructor() {
    super();
    this.state = {
      start_state: true,
      accepted_news: false,
      accepted_terms: false,
      name: "",
      nickname: "",
      mail: "",
      phone: "",
      pass: "",
      repass: "",
      msg: "",
      msg_type: "info",

      type: "",
      type_custom: false
    };
  }

  createLegend(json) {
    var legend = [];
    for (var i = 0; i < json["names"].length; i++) {
      var type = "fa fa-circle text-" + json["types"][i];
      legend.push(<i className={type} key={i} />);
      legend.push(" ");
      legend.push(json["names"][i]);
    }
    return legend;
  }

  updateByUser = async () => {
    
    if(this.state.name === "" || this.state.mail === "" || this.state.phone === "" || this.state.type === "") {
      this.setState({
        msg_type: "warning",
        msg: "Preencha todos os campos obrigatórios"
      });
    }
    else if(!this.state.accepted_terms) {
      this.setState({
        msg_type: "warning",
        msg: "Você precisa concordar com os termos"
      });
    }
    else {

      // console.log(this.state.name);
      var mutationReturn = (await account_client.mutate({
        variables: {
          id: this.state.id,
          type: this.state.type,
          name: this.state.name,
          mail: this.state.mail, 
          phone: this.state.phone, 
          uid: this.state.name, 
          is_blocked: 0,
          blocked_description: 0,
          profile_id: 0
        },
        mutation: REGISTER_UPDATE,
        fetchPolicy: 'no-cache'
      })).data.updateUser;

      // var settings = (await lms_client.query({
      //   query: GET_SETTINGS
      // })).data;


      if(mutationReturn && typeof mutationReturn.token != "undefined" && mutationReturn.token !== null && mutationReturn.token !== "") {
          document.cookie = "token_user="+mutationReturn.token;// Grava o cookie
          this.setState({
            msg_type: "info",
            msg: "Dados atualizados com sucesso."
          });
          window.location.replace('/');
      } else if(mutationReturn && typeof mutationReturn.msg_error != "undefined") {
        this.setState({
          msg_type: "warning",
          msg: mutationReturn.msg_error
        });
      }

      
      
    }
  }

  change_type = (event) => {
    
    if(event.target.value == "other") {
      this.setState({
        type_custom: true,
        type: ""
      });
    }
    else {
      this.setState({
        type_custom: false,
        type: event.target.value
      });
    }
    
  }
  change_type_text = (event) => {
    this.setState({type: event.target.value});
  }
  

  handleSubmit = (event) => {
    event.preventDefault();
    this.updateByUser();
  }

  handleCheckboxChange = (e) => {
    this.setState(state => ({
      ...state,
      accepted_terms: !this.state.accepted_terms
    }));
  }

  handleCheckboxChange_news = (e) => {
    this.setState(state => ({
      ...state,
      accepted_news: !this.state.accepted_news
    }));
  }

  onChange_name = (event) => {
    this.setState({name: event.target.value});
  }
  onChange_nickname = (event) => {
    this.setState({nickname: event.target.value});
  }
  onChange_mail = (event) => {
    this.setState({mail: event.target.value});
  }
  onChange_phone = (event) => {
    this.setState({phone: event.target.value});
  }
  onChange_pass = (event) => {
    this.setState({pass: event.target.value});
  }
  onChange_repass = (event) => {
    this.setState({repass: event.target.value});
  }
  

  render() {

    const windowWidth = window.innerWidth;

    var settings_banner = {
      autoplaySpeed: 5000,
      autoplay: true,
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };
    var settings_courses = {
      autoplay: false,
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: (windowWidth <= 987 ? 2 : 4),
      slidesToScroll: (windowWidth <= 987 ? 2 : 4)
    };

    // console.log("------------------====================");
    // console.log(this.props.match.params);

    return (
        
      <div>
        
        <Query
              client={account_client}
              fetchPolicy='no-cache'
                query={gql`{
                  get_authenticated_user{
                    id
                    name
                    mail
                    phone
                    uid
                    is_confirm
                  }
                }
                `}
            >
              {({ loading, error, data }) => {
                if (loading) return <div>Carregando...</div>;
                if (error) return <div>Erro :(</div>;

                  var authenticated_user = data.get_authenticated_user;

                  if(this.state.start_state) {
                    this.setState({
                      start_state: false,
                      id: authenticated_user.id
                    });
                  }

                  if(!authenticated_user.is_confirm || authenticated_user.name === "" || authenticated_user.mail === "") {
                    return (
                      <Grid fluid>
                      <div>
                        <form 
                        onSubmit={e => {
                          this.handleSubmit(e);
                          e.preventDefault();
                        }}
                        >
                          <h1 className="titleTop">Confirme Seus Dados</h1>

                          <FormInputs
                            ncols={["col-md-12"]}
                            proprieties={[
                              {
                                onChange:this.onChange_name,
                                name: "name",
                                label: "*Nome Completo",
                                type: "text",
                                bsClass: "form-control",
                                placeholder: "Nome Completo",
                                defaultValue: this.state.name
                              }
                            ]}
                          />

                      
                          <FormInputs
                            ncols={["col-md-12"]}
                            proprieties={[
                              {
                                onChange:this.onChange_mail,
                                name: "mail",
                                label: "*E-mail",
                                type: "mail",
                                bsClass: "form-control",
                                placeholder: "E-mail",
                                defaultValue: this.state.mail
                              }
                            ]}
                          />

                          <FormGroup>
                            <ControlLabel>*Celular</ControlLabel>
                            <div>
                            <InputMask 
                              className="form-control"
                              mask="(99) 9 9999-9999" 
                              value={this.state.phone} 
                              onChange={this.onChange_phone} 
                            />
                            </div>
                          </FormGroup> 



                          <FormGroup>
                            <ControlLabel>*Informe abaixo se você é:</ControlLabel>

                            <Query
                              client={account_client}
                              query={GET_AUTH_USER}
                              >
                              {({ loading, error, data }) => {
                                if (loading) return <tr><td>Carregando...</td></tr>;
                                if (error) return <tr><td>Erro 1:(</td></tr>;

                                var auth_user = data.get_authenticated_user;

                                return  ( 
                                  <div>
                                    {
                                      (!auth_user.profile || typeof auth_user.profile.id === "undefined" || auth_user.profile.id !== 2) &&
                                      <div>
                                        <div>
                                          <ControlLabel>
                                            <input
                                              value="Caminhoneiro(a)"
                                              name="type"
                                              type="radio"
                                              checked={this.state.type === "Caminhoneiro(a)"}
                                              onChange={this.change_type}
                                            /> Caminhoneiro(a)
                                          </ControlLabel>
                                        </div>
                                      </div>
                                    }
                                  </div>
                                );
                              }}
                              </Query>
                              <div>
                                <ControlLabel>
                                  <input
                                    value="Multiplicador"
                                    name="type"
                                    type="radio"
                                    checked={this.state.type === "Multiplicador"}
                                    onChange={this.change_type}
                                  /> Multiplicador
                                </ControlLabel>
                              </div>
                              <div>
                              <ControlLabel>
                                <input
                                  value="Ponto Focal"
                                  name="type"
                                  type="radio"
                                  checked={this.state.type === "Ponto Focal"}
                                  onChange={this.change_type}
                                /> Ponto Focal
                              </ControlLabel>
                              </div>
                              <div>
                              <ControlLabel>
                                <input
                                  value="other"
                                  name="type"
                                  type="radio"
                                  checked={this.state.type_custom}
                                  onChange={this.change_type}
                                /> Outro. Especificar:
                              </ControlLabel>
                              </div>


                            </FormGroup> 

                            {
                              this.state.type_custom &&
                              <FormInputs
                                ncols={["col-md-12"]}
                                proprieties={[
                                  {
                                    onChange:this.change_type_text,
                                    name: "name",
                                    label: "Especifique",
                                    type: "text",
                                    bsClass: "form-control",
                                    placeholder: "Especifique",
                                    defaultValue: this.state.type
                                  }
                                ]}
                              />
                            }

                        

                            <FormGroup>
                              <ControlLabel>
                                <input
                                  value="1"
                                  name="accepted_terms"
                                  type="checkbox"
                                  checked={this.state.accepted_terms}
                                  onChange={this.handleCheckboxChange}
                                /> Concordo com os <a target="_blank" href="/lms/assets/termos.pdf?v=2">termos e condições</a>
                              </ControlLabel>
                            </FormGroup>

                          <FormGroup>
                            <ControlLabel>
                              <input
                                value="1"
                                name="accepted_news"
                                type="checkbox"
                                checked={this.state.accepted_news}
                                onChange={this.handleCheckboxChange_news}
                              /> Aceito receber novidades
                            </ControlLabel>
                          </FormGroup>

                          <Row>
                            <Col md={12}>
                                <Button bsStyle="info" fill type="submit">
                                  ATUALIZAR DADOS
                                </Button>
                            </Col>
                            {
                              this.state.msg &&
                              <Col md={10}>
                                <Alert bsStyle={this.state.msg_type}>
                                  {this.state.msg}
                                </Alert>
                              </Col>
                            }
                            
                          </Row>

                    </form>
                      </div>

                    </Grid>
                    );
                  }


                  if(authenticated_user.is_confirm) {
                    return (
                      <div>
{
  /*
                          
      <div className="banner">
        <Query
            client={dam_client}
            variables={{module_name:"Banner"}}
            query={GET_DAM}
          >
            {({ loading, error, data }) => {
              if (loading) return <div>Carregando...</div>;
              if (error) return <div>Erro 1 :(</div>;
                
                if(!data.assets_collections) {
                  return (<div>(Vazio)</div>);
                } 
                return (
                  <Slider {...settings_banner}>
                        {data.assets_collections.assets.map((item, i) => (
                          <div key={item.id}>
                            <a 
                            data-gtm-type="click" 
                            data-gtm-clicktype="banner" 
                            data-gtm-name={item.title}
                            data-gtm-banner-index={i}
                            onClick={
                              // Registra que o usuário clicou no banner
                              () => analytics_client.mutate({
                                    variables:{banner_id:item.id, banner_title:item.title },
                                    mutation: ANALYTICS_INSERT_BANNER_CLICK
                                })
                            } href={item.directlink} target="_blank">
                              <img src={"/dam/assets/"+item.asset} />
                            </a>
                          </div>
                        ))}
                  </Slider>
                )
          }}
          </Query>
      </div>  
  */
}  
      
      <div className="content">

      <div className="container">
    <Grid className="rowCarousel">
          <Row>
            <Col md={12}>
              {
                this.props.match.params && this.props.match.params.category_id && typeof this.props.match.params.is_admin === "undefined" &&
                <TrailList category_id={this.props.match.params.category_id} />
              }
              {
                this.props.match.params && this.props.match.params.category_id && typeof this.props.match.params.is_admin !== "undefined" &&
                <TrailListReport category_id={this.props.match.params.category_id} />
              }

              {
                (!this.props.match.params || !this.props.match.params.category_id) &&
                <div>
                  <Query
                    client={account_client}
                    query={GET_AUTH_USER}
                    >
                    {({ loading, error, data }) => {
                      if (loading) return <tr><td>Carregando...</td></tr>;
                      if (error) return <tr><td>Erro 1:(</td></tr>;

                      var auth_user = data.get_authenticated_user;

                      return  ( 
                        <div>
                          {
                            auth_user.profile && auth_user.profile.id === 2 &&
                            <div>
                              <h1 className="title">Acesso administrador</h1>
                              <Table striped hover>
                                <tbody>
                                  <tr>
                                    <td>
                                      Relatório por usuário
                                      </td>
                                    <td>
                                      <a 
                                      className="btn btn-primary btn-fill pull-right"
                                      href={"/#/homeUsers"}>
                                      Ver usuários
                                      </a>
                                    </td>
                                    </tr>
                                </tbody>
                              </Table>
                              <CategoryListAdmin />
                              <hr />
                              <br />
                              <br />
                              
                              <h1 className="title">Acesso aos conteúdos</h1>
                               
                            </div>
                          }
                        </div>
                      );
                    }}
                    </Query>
                   
                      <CategoryList />
                     
                </div>
              }

              {
                /*
                   <Query
                      client={lms_client}
                      query={GET_CURSES}
                      >
                      {({ loading, error, data }) => {
                        if (loading) return <div>Carregando...</div>;
                        if (error) return <div>Erro :(</div>;
                          
                          return (
                            <Slider {...settings_courses}>
                                  {data.courses_collections.courses.map((item) => (
                                    <div key={item.id} className="course-item">
                                      <a 
                                      data-gtm-type="click" 
                                      data-gtm-clicktype="card" 
                                      data-gtm-name={item.title}
                                      href={"/#/curso/"+item.id}>
                                        <img src={"/lms/assets/"+item.thumbnail} />
                                        <div className="title">{item.title}</div>
                                      </a>
                                    </div>
                                  ))}
                            </Slider>
                          )
                    }}
                    </Query>
                */
              }
              <div className="both"></div>
               
            </Col>
          </Row>

        </Grid>
        </div>
        </div>
        </div>
      
    
                      );
                  }
          }}
        </Query>
        <div className="both"></div>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Home/Home.jsx